(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    if (window.wovenCartReady) return;
    window.wovenCartReady = true;
    const rootSelector = '[data-cart-root]';

    const setBusy = (root, busy) => {
      root.setAttribute('aria-busy', String(busy));
      root.querySelectorAll('button').forEach((button) => { button.disabled = busy; });
    };

    const setDiscountBusy = (trigger, busy) => {
      if (!trigger) return;
      trigger.disabled = busy;
      trigger.setAttribute('aria-busy', String(busy));
      if (trigger.matches('[data-discount-apply]')) {
        if (busy) {
          trigger.dataset.discountLoading = 'true';
          trigger.setAttribute('aria-label', 'Applying discount code');
        } else {
          delete trigger.dataset.discountLoading;
          trigger.removeAttribute('aria-label');
        }
      }
    };

    const showError = (root, message) => {
      const error = root.querySelector('[data-cart-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    };

    const refreshSection = async (root, cart, announcement = 'Your bag has been updated.') => {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unable to refresh the bag.');
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector(rootSelector);
      if (!replacement) throw new Error('Unable to refresh the bag.');
      root.replaceWith(replacement);

      const headerCount = document.querySelector('.woven-header__cart-count');
      const headerLink = document.querySelector('.woven-header__cart');
      if (headerCount) headerCount.textContent = `(${cart.item_count})`;
      if (headerLink) headerLink.setAttribute('aria-label', `Cart with ${cart.item_count} items`);

      const status = replacement.querySelector('[data-cart-status]');
      if (status) status.textContent = announcement;
      return replacement;
    };

    const updateCart = async (root, updates) => {
      setBusy(root, true);
      const note = root.querySelector('[name="note"]');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, note: note ? note.value : undefined }),
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || 'We couldn’t update your bag.');
        await refreshSection(root, cart);
      } catch (error) {
        setBusy(root, false);
        showError(root, error.message || 'We couldn’t update your bag. Please try again.');
      }
    };

    const showDiscountMessage = (root, message) => {
      const target = root.querySelector('[data-discount-message]');
      if (!target) return;
      target.textContent = message;
      target.hidden = false;
    };

    const changeDiscount = async (root, mode, code, trigger) => {
      const api = window.wovenCartDiscounts;
      if (!api) {
        showError(root, 'Discount codes are unavailable right now. Please try again.');
        return;
      }
      setDiscountBusy(trigger, true);
      try {
        const current = await api.get();
        const cart = mode === 'add' ? await api.add(current, code) : await api.remove(current, code);
        const problem = api.problem(cart, code, mode);
        if (problem && mode === 'add') {
          showDiscountMessage(root, problem);
          return;
        }
        const announcement = mode === 'add' ? 'Discount applied.' : 'Discount removed.';
        const replacement = await refreshSection(root, cart, problem ? '' : announcement);
        if (problem) showDiscountMessage(replacement, problem);
      } catch (error) {
        showError(root, error.message || 'We couldn’t update your discount. Please try again.');
      } finally {
        if (trigger?.isConnected) setDiscountBusy(trigger, false);
      }
    };

    document.addEventListener('click', (event) => {
      const root = event.target.closest(rootSelector);
      if (!root) return;

      const discountApply = event.target.closest('[data-discount-apply]');
      if (discountApply) {
        const input = root.querySelector('[data-discount-input]');
        const code = (input?.value || '').trim();
        if (!code) {
          input?.focus();
          return;
        }
        changeDiscount(root, 'add', code, discountApply);
        return;
      }

      const discountRemove = event.target.closest('[data-discount-remove]');
      if (discountRemove) {
        changeDiscount(root, 'remove', discountRemove.dataset.discountRemove, discountRemove);
        return;
      }

      const line = event.target.closest('[data-cart-line]');

      if (line && event.target.closest('[data-quantity-minus], [data-quantity-plus]')) {
        const input = line.querySelector('[data-quantity-input]');
        const change = event.target.closest('[data-quantity-plus]') ? 1 : -1;
        const quantity = Math.max(0, Number.parseInt(input.value || '0', 10) + change);
        input.value = String(quantity);
        updateCart(root, { [line.dataset.lineKey]: quantity });
        return;
      }

      if (line && event.target.closest('[data-remove-line]')) {
        updateCart(root, { [line.dataset.lineKey]: 0 });
        return;
      }

      if (event.target.closest('[data-cart-update]')) {
        const updates = {};
        root.querySelectorAll('[data-cart-line]').forEach((cartLine) => {
          const input = cartLine.querySelector('[data-quantity-input]');
          updates[cartLine.dataset.lineKey] = Math.max(0, Number.parseInt(input.value || '0', 10));
        });
        updateCart(root, updates);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (!event.target.matches(`${rootSelector} [data-discount-input]`)) return;
      event.preventDefault();
      event.target.closest(rootSelector).querySelector('[data-discount-apply]')?.click();
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches(`${rootSelector} [data-quantity-input]`)) return;
      const root = event.target.closest(rootSelector);
      const line = event.target.closest('[data-cart-line]');
      const quantity = Math.max(0, Number.parseInt(event.target.value || '0', 10));
      event.target.value = String(quantity);
      updateCart(root, { [line.dataset.lineKey]: quantity });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-woven-collection]').forEach((root) => {
      const form = root.querySelector('[data-facet-form]');
      const openButton = root.querySelector('[data-filter-open]');
      const closeButton = root.querySelector('[data-filter-close]');
      const scrim = root.querySelector('[data-filter-scrim]');
      const status = root.querySelector('[data-catalog-status]');
      let lastFocus = null;
      const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
      const closeFilters = () => { form?.classList.remove('is-open'); scrim?.classList.remove('is-open'); openButton?.setAttribute('aria-expanded','false'); document.documentElement.style.overflow=''; lastFocus?.focus(); };
      const openFilters = () => { lastFocus=document.activeElement; form?.classList.add('is-open'); scrim?.classList.add('is-open'); openButton?.setAttribute('aria-expanded','true'); document.documentElement.style.overflow='hidden'; closeButton?.focus(); };
      openButton?.addEventListener('click',openFilters); closeButton?.addEventListener('click',closeFilters); scrim?.addEventListener('click',closeFilters);
      document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&form?.classList.contains('is-open'))closeFilters();});
      form?.querySelectorAll('input[type="checkbox"],input[type="radio"]').forEach((input)=>input.addEventListener('change',()=>{if(!isMobile())form.requestSubmit();}));
      form?.querySelector('[data-sort-select]')?.addEventListener('change',()=>form.requestSubmit());
      form?.querySelectorAll('[data-facet]').forEach((facet)=>facet.addEventListener('toggle',()=>{if(!facet.open||isMobile())return;form.querySelectorAll('[data-facet][open]').forEach((other)=>{if(other!==facet)other.removeAttribute('open');});}));

      const updateWishlists=()=>{let saved=[];try{saved=JSON.parse(localStorage.getItem('woven-wishlist')||'[]');}catch(_){}root.querySelectorAll('[data-wishlist]').forEach((button)=>{const id=button.closest('[data-product-id]')?.dataset.productId;const active=saved.includes(id);button.classList.toggle('is-saved',active);button.setAttribute('aria-pressed',String(active));button.setAttribute('aria-label',`${active?'Remove product from':'Add product to'} wishlist`);});};
      updateWishlists();
      root.addEventListener('click',async(event)=>{
        const wishlist=event.target.closest('[data-wishlist]');
        if(wishlist){const id=wishlist.closest('[data-product-id]')?.dataset.productId;let saved=[];try{saved=JSON.parse(localStorage.getItem('woven-wishlist')||'[]');}catch(_){}saved=saved.includes(id)?saved.filter((item)=>item!==id):[...saved,id];localStorage.setItem('woven-wishlist',JSON.stringify(saved));updateWishlists();return;}
        const addButton=event.target.closest('[data-quick-add]');
        if(addButton){addButton.disabled=true;addButton.textContent='Adding';try{const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(addButton.dataset.variantId),quantity:1}]})});if(!response.ok)throw new Error('Add failed');const cart=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`).then((result)=>result.json());document.querySelectorAll('.woven-header__cart-count').forEach((count)=>{count.textContent=`(${cart.item_count})`;});addButton.textContent='Added';if(status)status.textContent='Product added to your bag.';}catch(_){addButton.textContent='Try again';if(status)status.textContent='The product could not be added. Please try again.';}finally{window.setTimeout(()=>{addButton.disabled=false;if(addButton.textContent!=='Try again')addButton.textContent='Quick add';},1400);}return;}
        const loadButton=event.target.closest('[data-load-more]');
        if(loadButton){loadButton.disabled=true;loadButton.classList.add('is-loading');loadButton.textContent='Loading';try{const html=await fetch(loadButton.dataset.nextUrl).then((response)=>response.text());const page=new DOMParser().parseFromString(html,'text/html');const incoming=page.querySelectorAll('[data-product-grid] > .woven-product-card');const grid=root.querySelector('[data-product-grid]');incoming.forEach((card)=>grid.appendChild(card));const next=page.querySelector('[data-load-more]');const nextCount=page.querySelector('[data-pagination] span');if(next){loadButton.dataset.nextUrl=next.dataset.nextUrl;loadButton.disabled=false;loadButton.classList.remove('is-loading');loadButton.textContent='Load more';const count=loadButton.parentElement.querySelector('span');if(count&&nextCount)count.textContent=nextCount.textContent;}else{loadButton.parentElement.remove();}updateWishlists();if(status)status.textContent=`${incoming.length} more products loaded.`;}catch(_){loadButton.disabled=false;loadButton.classList.remove('is-loading');loadButton.textContent='Try again';}}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const initFooter = (root) => {
      if (!root || root.dataset.footerInitialized === 'true') return;
      root.dataset.footerInitialized = 'true';

      const menus = [...root.querySelectorAll('.woven-footer__menu')];
      const mobile = window.matchMedia('(max-width: 768px)');
      let mobileInitialized = false;

      const syncMenus = () => {
        if (mobile.matches) {
          if (!mobileInitialized) {
            menus.forEach((menu, index) => { menu.open = index === 0; });
            mobileInitialized = true;
          }
        } else {
          menus.forEach((menu) => { menu.open = true; });
          mobileInitialized = false;
        }
      };

      menus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!mobile.matches || !menu.open) return;
          menus.forEach((otherMenu) => {
            if (otherMenu !== menu) otherMenu.open = false;
          });
        });
      });

      syncMenus();
      mobile.addEventListener('change', syncMenus);
    };

    document.querySelectorAll('[data-woven-footer]').forEach(initFooter);
    document.addEventListener('shopify:section:load', (event) => initFooter(event.target.querySelector('[data-woven-footer]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initHeader = (root) => {
      if (!root || root.dataset.headerInitialized === 'true') return;
      root.dataset.headerInitialized = 'true';

      const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Collections mega panel */
      const megaToggle = root.querySelector('[data-mega-toggle]');
      const megaPanel = root.querySelector('[data-mega-panel]');
      const setMega = (open) => {
        if (!megaPanel || !megaToggle) return;
        megaPanel.hidden = !open;
        megaToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      megaToggle?.addEventListener('click', () => setMega(megaPanel.hidden));
      document.addEventListener('click', (event) => {
        if (!megaPanel || megaPanel.hidden) return;
        if (!megaPanel.contains(event.target) && !megaToggle.contains(event.target)) setMega(false);
      });
      megaPanel?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMega(false)));

      /* Search overlay */
      const searchOverlay = root.querySelector('[data-search-overlay]');
      const searchOpenButton = root.querySelector('[data-search-open]');
      const searchCloseButton = root.querySelector('[data-search-close]');
      const searchInput = root.querySelector('[data-search-input]');

      const closeSearch = () => {
        if (!searchOverlay || !searchOverlay.open) return;
        searchOverlay.classList.remove('is-open');
        window.setTimeout(() => {
          searchOverlay.close();
          searchOpenButton?.focus();
        }, reduceMotion() ? 0 : 220);
      };

      searchOpenButton?.addEventListener('click', () => {
        if (!searchOverlay) return;
        setMega(false);
        searchOverlay.showModal();
        window.requestAnimationFrame(() => {
          searchOverlay.classList.add('is-open');
          searchInput?.focus();
        });
      });
      searchCloseButton?.addEventListener('click', closeSearch);
      searchOverlay?.addEventListener('cancel', (event) => { event.preventDefault(); closeSearch(); });
      searchOverlay?.addEventListener('click', (event) => { if (event.target === searchOverlay) closeSearch(); });

      /* Wishlist badge */
      const wishlistCount = root.querySelector('[data-wishlist-count]');
      const updateWishlistCount = () => {
        if (!wishlistCount) return;
        let saved = [];
        try { saved = JSON.parse(localStorage.getItem('woven-wishlist') || '[]'); } catch (_) {}
        wishlistCount.textContent = saved.length;
        wishlistCount.hidden = saved.length === 0;
      };
      updateWishlistCount();
      window.addEventListener('storage', (event) => { if (event.key === 'woven-wishlist') updateWishlistCount(); });
      window.addEventListener('focus', updateWishlistCount);

      /* Mobile drawer */
      const dialog = root.querySelector('[data-menu-dialog]');
      const openButton = root.querySelector('[data-menu-open]');
      const closeButton = root.querySelector('[data-menu-close]');

      const setLevel = (name) => {
        root.querySelectorAll('[data-drawer-level]').forEach((level) => {
          const active = level.dataset.drawerLevel === name;
          level.classList.toggle('is-current', active);
          level.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      const closeMenu = () => {
        if (!dialog || !dialog.open) return;
        dialog.classList.remove('is-open');
        window.setTimeout(() => {
          dialog.close();
          setLevel('main');
          openButton?.focus();
        }, reduceMotion() ? 0 : 300);
      };

      openButton?.addEventListener('click', () => {
        if (!dialog) return;
        dialog.showModal();
        window.requestAnimationFrame(() => dialog.classList.add('is-open'));
      });
      closeButton?.addEventListener('click', closeMenu);
      dialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeMenu(); });
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeMenu(); });
      root.querySelectorAll('[data-drawer-next]').forEach((button) => button.addEventListener('click', () => setLevel(button.dataset.drawerNext)));
      root.querySelectorAll('[data-drawer-back]').forEach((button) => button.addEventListener('click', () => setLevel('main')));
      dialog?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMega(false); });

      /* Spec 09: shadow-1 appears only once the sticky header detaches. */
      const bar = root.querySelector('[data-header-bar]');
      const onScroll = () => bar?.classList.toggle('is-scrolled', window.scrollY > 0);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    };

    document.querySelectorAll('[data-woven-header]').forEach(initHeader);
    document.addEventListener('shopify:section:load', (event) => initHeader(event.target.querySelector('[data-woven-header]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-root]:not([data-product-ready])');
    roots.forEach((root) => {
      root.dataset.productReady = 'true';
      const variantsNode = root.querySelector('[data-product-variants]');
      const recentNode = root.querySelector('[data-recent-product]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const form = root.querySelector('[data-product-form]');
      const variantInput = root.querySelector('[data-variant-id]');
      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-product-compare]');
      const stock = root.querySelector('[data-product-stock]');
      const stockMessage = root.querySelector('[data-stock-message]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      const status = root.querySelector('[data-product-status]');
      const sticky = root.querySelector('[data-mobile-sticky]');
      const stickyButton = root.querySelector('[data-sticky-submit]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const wishlistButton = root.querySelector('[data-product-wishlist]');
      const shareButton = root.querySelector('[data-product-share]');
      const actionStatus = root.querySelector('[data-product-action-status]');
      const availableText = stockMessage?.textContent.trim() || 'Available to order';
      const productId = root.dataset.productId;
      const productTitle = root.querySelector('h1')?.textContent.trim() || document.title;

      const getSavedProducts = () => {
        try { return JSON.parse(localStorage.getItem('woven-wishlist') || '[]'); }
        catch (_) { return []; }
      };
      const updateWishlistButton = () => {
        if (!wishlistButton) return;
        const isSaved = getSavedProducts().includes(productId);
        wishlistButton.classList.toggle('is-saved', isSaved);
        wishlistButton.setAttribute('aria-pressed', String(isSaved));
        wishlistButton.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Save'} ${productTitle} ${isSaved ? 'from' : 'to'} wishlist`);
      };
      updateWishlistButton();

      wishlistButton?.addEventListener('click', () => {
        const saved = getSavedProducts();
        const next = saved.includes(productId) ? saved.filter((id) => id !== productId) : [...saved, productId];
        try { localStorage.setItem('woven-wishlist', JSON.stringify(next)); } catch (_) {}
        updateWishlistButton();
        if (actionStatus) actionStatus.textContent = next.includes(productId) ? 'Saved to your wishlist.' : 'Removed from your wishlist.';
      });

      shareButton?.addEventListener('click', async () => {
        const shareData = { title: productTitle, text: productTitle, url: window.location.href };
        try {
          if (navigator.share) {
            await navigator.share(shareData);
            if (actionStatus) actionStatus.textContent = 'Product shared.';
          } else {
            await navigator.clipboard.writeText(window.location.href);
            if (actionStatus) actionStatus.textContent = 'Product link copied.';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && actionStatus) actionStatus.textContent = 'The product link could not be copied.';
        }
      });

      const selectedOptions = () => Array.from(root.querySelectorAll('.woven-product-option')).map((group) => group.querySelector('input:checked')?.value);

      const applyVariant = (variant, updateUrl = true) => {
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = variant.priceFormatted;
        stickyPrice.textContent = variant.priceFormatted;
        if (variant.compareAtPrice > variant.price) {
          compare.textContent = variant.compareAtPriceFormatted;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
        stock.classList.toggle('is-unavailable', !variant.available);
        stockMessage.textContent = variant.available ? availableText : 'Currently unavailable';
        addButton.disabled = !variant.available;
        stickyButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? 'Add to Cart' : 'Currently unavailable';
        stickyButton.textContent = variant.available ? 'Add to Cart' : 'Unavailable';
        if (variant.featuredMediaId) {
          const mediaIndex = mediaItems.findIndex((item) => item.dataset.galleryMedia === String(variant.featuredMediaId));
          if (mediaIndex > -1) setActiveMedia(mediaIndex, true);
        }
        if (updateUrl && window.history?.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };

      const refreshOptionStates = () => {
        const chosen = selectedOptions();
        root.querySelectorAll('.woven-product-option').forEach((group, optionIndex) => {
          group.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.disabled = !variants.some((variant) => variant.available && variant.options.every((value, index) => index === optionIndex ? value === input.value : (!chosen[index] || value === chosen[index])));
          });
          const selected = group.querySelector('input:checked');
          const output = group.querySelector('[data-option-selected]');
          if (selected && output) output.textContent = selected.value;
        });
      };

      root.querySelectorAll('.woven-product-option input').forEach((input) => {
        input.addEventListener('change', () => {
          const chosen = selectedOptions();
          let variant = variants.find((item) => item.options.every((value, index) => value === chosen[index]));
          if (!variant) {
            const changedIndex = Number(input.closest('[data-option-index]')?.dataset.optionIndex || 0);
            variant = variants.find((item) => item.available && item.options[changedIndex] === input.value);
            if (variant) {
              root.querySelectorAll('.woven-product-option').forEach((group, index) => {
                const matching = Array.from(group.querySelectorAll('input')).find((radio) => radio.value === variant.options[index]);
                if (matching) matching.checked = true;
              });
            }
          }
          applyVariant(variant);
          refreshOptionStates();
        });
      });
      refreshOptionStates();

      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        const input = root.querySelector('input[name="quantity"]');
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        const input = root.querySelector('input[name="quantity"]');
        input.value = Number(input.value || 1) + 1;
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        addButton.disabled = true;
        addButton.classList.add('is-loading');
        status.classList.remove('is-error');
        status.textContent = 'Adding to your cart…';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'This item could not be added.');
          status.textContent = 'Added to your cart.';
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
          const cart = await cartResponse.json();
          document.querySelectorAll('.woven-header__cart-count').forEach((count) => { count.textContent = `(${cart.item_count})`; });
          document.dispatchEvent(new CustomEvent('woven:cart:open', {
            detail: { trigger: addButton, announcement: 'Added to your cart.' },
          }));
        } catch (error) {
          status.classList.add('is-error');
          status.textContent = error.message;
        } finally {
          addButton.classList.remove('is-loading');
          const selected = variants.find((item) => String(item.id) === String(variantInput.value));
          addButton.disabled = !selected?.available;
        }
      });
      stickyButton?.addEventListener('click', () => form?.requestSubmit());

      if (sticky && addButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          const visible = !entry.isIntersecting && window.matchMedia('(max-width: 767px)').matches;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
        }, { threshold: 0.2 });
        observer.observe(addButton);
      }

      const stage = root.querySelector('[data-gallery-stage]');
      const thumbsRail = root.querySelector('.woven-gallery__thumbs');
      const mediaItems = Array.from(root.querySelectorAll('[data-gallery-media]'));
      const setActiveMedia = (index, shouldScroll = false) => {
        mediaItems.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
        });
        root.querySelectorAll('[data-gallery-dot]').forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
        root.querySelectorAll('[data-gallery-thumb]').forEach((thumb, thumbIndex) => thumb.setAttribute('aria-current', String(thumbIndex === index)));
        if (shouldScroll) {
          if (window.matchMedia('(max-width: 767px)').matches) {
            stage?.scrollTo({ left: stage.clientWidth * index, behavior: 'smooth' });
          } else if (thumbsRail && thumbsRail.scrollHeight > thumbsRail.clientHeight) {
            const activeThumb = thumbsRail.querySelector(`[data-gallery-thumb="${index}"]`);
            if (activeThumb) {
              thumbsRail.scrollTo({ top: activeThumb.offsetTop - (thumbsRail.clientHeight - activeThumb.clientHeight) / 2, behavior: 'smooth' });
            }
          }
        }
      };
      root.querySelectorAll('[data-gallery-dot]').forEach((dot) => dot.addEventListener('click', () => setActiveMedia(Number(dot.dataset.galleryDot), true)));
      root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => setActiveMedia(Number(thumb.dataset.galleryThumb), true)));
      let scrollFrame;
      stage?.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          if (window.matchMedia('(max-width: 767px)').matches) setActiveMedia(Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1)));
        });
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        const desktopMediaObserver = new IntersectionObserver((entries) => {
          if (!window.matchMedia('(min-width: 768px)').matches) return;
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) setActiveMedia(mediaItems.indexOf(visible.target));
        }, { rootMargin: '-15% 0px -55% 0px', threshold: [0, 0.2, 0.5, 0.8] });
        mediaItems.forEach((item) => desktopMediaObserver.observe(item));
      }

      mediaItems.forEach((item) => {
        item.addEventListener('pointermove', (event) => {
          if (!window.matchMedia('(min-width: 768px)').matches || event.pointerType === 'touch') return;
          const bounds = item.getBoundingClientRect();
          item.style.setProperty('--zoom-x', `${((event.clientX - bounds.left) / bounds.width) * 100}%`);
          item.style.setProperty('--zoom-y', `${((event.clientY - bounds.top) / bounds.height) * 100}%`);
          item.classList.add('is-zoomed');
        });
        item.addEventListener('pointerleave', () => item.classList.remove('is-zoomed'));
      });

      try {
        const current = recentNode ? JSON.parse(recentNode.textContent) : null;
        if (!current) return;
        const key = 'woven-recently-viewed';
        const history = JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item.id !== current.id);
        const recentSection = root.querySelector('[data-recently-viewed]');
        const recentGrid = root.querySelector('[data-recently-viewed-grid]');
        if (history.length >= 2 && recentSection && recentGrid) {
          history.slice(0, 4).forEach((item) => {
            const card = document.createElement('article'); card.className = 'woven-pdp-card';
            const imageLink = document.createElement('a'); imageLink.className = 'woven-pdp-card__image'; imageLink.href = item.url;
            if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.title; image.loading = 'lazy'; imageLink.appendChild(image); }
            const heading = document.createElement('h3'); const titleLink = document.createElement('a'); titleLink.href = item.url; titleLink.textContent = item.title; heading.appendChild(titleLink);
            const itemPrice = document.createElement('p'); itemPrice.className = 'woven-pdp-card__price'; itemPrice.textContent = item.price;
            card.append(imageLink, heading, itemPrice);
            if (item.meta) { const meta = document.createElement('p'); meta.className = 'woven-pdp-card__meta'; meta.textContent = item.meta; card.appendChild(meta); }
            recentGrid.appendChild(card);
          });
          recentSection.hidden = false;
        }
        localStorage.setItem(key, JSON.stringify([current, ...history].slice(0, 8)));
      } catch (_) {
        /* Recently viewed remains optional when storage is unavailable. */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const RECENT_KEY = 'woven-recent-searches';
    const WISHLIST_KEY = 'woven-wishlist';

    const readStore = (key) => {
      try {
        const value = JSON.parse(window.localStorage.getItem(key) || '[]');
        return Array.isArray(value) ? value : [];
      } catch (_) {
        return [];
      }
    };

    const writeStore = (key, value) => {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (_) {
        /* storage unavailable — recent searches simply do not persist */
      }
    };

    document.querySelectorAll('[data-woven-search]').forEach((root) => {
      const input = root.querySelector('[data-search-input]');
      const clearButton = root.querySelector('[data-search-clear]');
      const status = root.querySelector('[data-search-status]');
      const searchUrl = `${window.Shopify?.routes?.root || '/'}search`;

      /* Clear field */
      const syncClear = () => {
        if (clearButton) clearButton.hidden = !input?.value;
      };
      input?.addEventListener('input', syncClear);
      clearButton?.addEventListener('click', () => {
        if (!input) return;
        input.value = '';
        syncClear();
        input.focus();
      });
      syncClear();

      /* Recent searches */
      const currentTerms = (input?.defaultValue || '').trim();
      if (currentTerms) {
        const recent = readStore(RECENT_KEY).filter((term) => term.toLowerCase() !== currentTerms.toLowerCase());
        recent.unshift(currentTerms);
        writeStore(RECENT_KEY, recent.slice(0, 6));
      }

      const recentWrapper = root.querySelector('[data-recent-searches]');
      const recentList = root.querySelector('[data-recent-list]');

      const renderRecent = () => {
        if (!recentWrapper || !recentList) return;
        const recent = readStore(RECENT_KEY).filter((term) => term && term.toLowerCase() !== currentTerms.toLowerCase());
        recentList.replaceChildren();
        recent.slice(0, 6).forEach((term) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `${searchUrl}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
          link.textContent = term;
          item.appendChild(link);
          recentList.appendChild(item);
        });
        recentWrapper.hidden = recent.length === 0;
      };

      root.querySelector('[data-recent-clear]')?.addEventListener('click', () => {
        writeStore(RECENT_KEY, []);
        renderRecent();
      });
      renderRecent();

      /* Wishlist */
      const syncWishlist = () => {
        const saved = readStore(WISHLIST_KEY);
        root.querySelectorAll('[data-wishlist]').forEach((button) => {
          const id = button.closest('[data-product-id]')?.dataset.productId;
          const active = saved.includes(id);
          button.classList.toggle('is-saved', active);
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute('aria-label', `${active ? 'Remove product from' : 'Add product to'} wishlist`);
        });
      };
      syncWishlist();

      root.addEventListener('click', async (event) => {
        const wishlistButton = event.target.closest('[data-wishlist]');
        if (wishlistButton) {
          const id = wishlistButton.closest('[data-product-id]')?.dataset.productId;
          const saved = readStore(WISHLIST_KEY);
          writeStore(WISHLIST_KEY, saved.includes(id) ? saved.filter((item) => item !== id) : [...saved, id]);
          syncWishlist();
          return;
        }

        const addButton = event.target.closest('[data-quick-add]');
        if (!addButton) return;

        addButton.disabled = true;
        addButton.textContent = 'Adding';
        try {
          const root_url = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root_url}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(addButton.dataset.variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Add failed');
          const cart = await fetch(`${root_url}cart.js`).then((result) => result.json());
          document.querySelectorAll('.woven-header__cart-count').forEach((count) => {
            count.textContent = `(${cart.item_count})`;
          });
          addButton.textContent = 'Added';
          if (status) status.textContent = 'Product added to your bag.';
          document.dispatchEvent(new CustomEvent('woven:cart:open', { detail: { trigger: addButton, announcement: 'Added to your bag.' } }));
        } catch (_) {
          addButton.textContent = 'Try again';
          if (status) status.textContent = 'The product could not be added. Please try again.';
        } finally {
          window.setTimeout(() => {
            addButton.disabled = false;
            if (addButton.textContent !== 'Try again') addButton.textContent = 'Quick add';
          }, 1400);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  (() => {
    const initialiseWishlist = (root) => {
      if (!root || root.dataset.wishlistReady === 'true') return;
      root.dataset.wishlistReady = 'true';
      const storageKey = 'woven-wishlist';
      const grid = root.querySelector('[data-wishlist-grid]');
      const empty = root.querySelector('[data-wishlist-empty]');
      const loading = root.querySelector('[data-wishlist-loading]');
      const summary = root.querySelector('[data-wishlist-summary]');
      const status = root.querySelector('[data-wishlist-status]');
      const cards = [...root.querySelectorAll('[data-wishlist-card]')];

      const getSaved = () => {
        try {
          const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
          return Array.isArray(value) ? [...new Set(value.map(String))] : [];
        } catch (_) { return []; }
      };
      const updateHeaderCount = (count) => {
        document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
          badge.textContent = count;
          badge.hidden = count === 0;
        });
      };
      const render = () => {
        const saved = getSaved();
        const byId = new Map(cards.map((card) => [card.dataset.productId, card]));
        const visibleCards = saved.map((id) => byId.get(id)).filter(Boolean);
        cards.forEach((card) => { card.hidden = true; });
        visibleCards.forEach((card) => { card.hidden = false; grid?.appendChild(card); });
        if (loading) loading.hidden = true;
        if (grid) grid.hidden = visibleCards.length === 0;
        if (empty) empty.hidden = visibleCards.length > 0;
        if (summary) {
          summary.textContent = `${visibleCards.length} ${visibleCards.length === 1 ? 'piece' : 'pieces'} saved`;
          summary.hidden = visibleCards.length === 0;
        }
        root.dataset.ready = 'true';
        updateHeaderCount(saved.length);
      };
      const save = (items) => {
        try { localStorage.setItem(storageKey, JSON.stringify(items)); } catch (_) {}
        render();
      };

      root.addEventListener('click', async (event) => {
        const removeButton = event.target.closest('[data-wishlist-remove]');
        if (removeButton) {
          const card = removeButton.closest('[data-wishlist-card]');
          if (!card) return;
          const title = card.querySelector('h2')?.textContent.trim() || 'Item';
          save(getSaved().filter((id) => id !== card.dataset.productId));
          if (status) status.textContent = `${title} removed from your wishlist.`;
          return;
        }
        const addButton = event.target.closest('[data-wishlist-add]');
        if (!addButton) return;
        addButton.disabled = true;
        addButton.textContent = 'Adding';
        try {
          const rootUrl = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(addButton.dataset.variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Add failed');
          const cart = await fetch(`${rootUrl}cart.js`).then((result) => result.json());
          document.querySelectorAll('.woven-header__cart-count').forEach((count) => { count.textContent = `(${cart.item_count})`; });
          addButton.textContent = 'Added';
          if (status) status.textContent = 'Product added to your bag.';
        } catch (_) {
          addButton.textContent = 'Try again';
          if (status) status.textContent = 'The product could not be added. Please try again.';
        } finally {
          window.setTimeout(() => {
            addButton.disabled = false;
            if (addButton.textContent !== 'Try again') addButton.textContent = 'Add to bag';
          }, 1400);
        }
      });

      render();
      window.addEventListener('storage', (event) => { if (event.key === storageKey) render(); });
      window.addEventListener('focus', render);
    };
    document.querySelectorAll('[data-woven-wishlist-page]').forEach(initialiseWishlist);
    document.addEventListener('shopify:section:load', (event) => initialiseWishlist(event.target.querySelector('[data-woven-wishlist-page]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woven-footer-4-columns"]) return;
  try {
    
  (() => {
    const initFooter = (root) => {
      if (!root || root.dataset.footerInitialized === 'true') return;
      root.dataset.footerInitialized = 'true';

      const menus = [...root.querySelectorAll('.woven-footer__menu')];
      const mobile = window.matchMedia('(max-width: 768px)');
      let mobileInitialized = false;

      const syncMenus = () => {
        if (mobile.matches) {
          if (!mobileInitialized) {
            menus.forEach((menu, index) => { menu.open = index === 0; });
            mobileInitialized = true;
          }
        } else {
          menus.forEach((menu) => { menu.open = true; });
          mobileInitialized = false;
        }
      };

      menus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!mobile.matches || !menu.open) return;
          menus.forEach((otherMenu) => {
            if (otherMenu !== menu) otherMenu.open = false;
          });
        });
      });

      syncMenus();
      mobile.addEventListener('change', syncMenus);
    };

    document.querySelectorAll('[data-woven-footer]').forEach(initFooter);
    document.addEventListener('shopify:section:load', (event) => initFooter(event.target.querySelector('[data-woven-footer]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
